import React, { useEffect, useRef, useState } from 'react';
import { assetUrl } from '../utils/assetUrl';

// Retry a failed image after transient network loss, including Android resume.
// The parent keys this component by URL so each banner gets its own retry budget.
export default function BannerImage({ src, alt = 'Banner', onLoad, ...props }) {
  const [attempt, setAttempt] = useState(0);
  const failed = useRef(false);
  const timer = useRef(null);
  useEffect(() => {
    const retry = () => {
      if (failed.current) { failed.current = false; setAttempt(value => value + 1); }
    };
    window.addEventListener('online', retry);
    window.addEventListener('focus', retry);
    return () => {
      clearTimeout(timer.current);
      window.removeEventListener('online', retry);
      window.removeEventListener('focus', retry);
    };
  }, []);
  const url = assetUrl(src);
  return <img {...props} alt={alt} src={attempt ? `${url}${url.includes('?') ? '&' : '?'}retry=${attempt}` : url}
    onLoad={event => { failed.current = false; clearTimeout(timer.current); onLoad?.(event); }}
    onError={() => {
      failed.current = true;
      clearTimeout(timer.current);
      if (attempt < 2) timer.current = setTimeout(() => setAttempt(value => value + 1), 1000 * (attempt + 1));
    }} />;
}
